export const SEGMENT_EVENTS = {
  ACCOUNT_CREATED: 'Account Created',
  ACCOUNT_AUTHENTICATED: 'Account Authenticated',
  ORDER_STARTED: 'Order Started',
  ORDER_SUBMITTED: 'Order Submitted',
};

export default SEGMENT_EVENTS;
